var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.6654 14.6665H10.6654M13.332 19.9998H10.6654M21.332 9.33317H10.6654M26.6654 9.0665V22.9332C26.6654 25.1734 26.6654 26.2935 26.2294 27.1491C25.8459 27.9018 25.234 28.5137 24.4813 28.8972C23.6257 29.3332 22.5056 29.3332 20.2654 29.3332H11.732C9.49182 29.3332 8.37172 29.3332 7.51607 28.8972C6.76342 28.5137 6.1515 27.9018 5.76801 27.1491C5.33203 26.2935 5.33203 25.1734 5.33203 22.9332V9.0665C5.33203 6.82629 5.33203 5.70619 5.76801 4.85054C6.1515 4.09789 6.76342 3.48597 7.51607 3.10248C8.37172 2.6665 9.49182 2.6665 11.732 2.6665H20.2654C22.5056 2.6665 23.6257 2.6665 24.4813 3.10248C25.234 3.48597 25.8459 4.09789 26.2294 4.85054C26.6654 5.70619 26.6654 6.82629 26.6654 9.0665Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile02);
export default __webpack_public_path__ + "static/media/file-02.ca0fe49f5955d2b15024fb04ef90264c.svg";
export { ForwardRef as ReactComponent };